import { Box, Flex } from '@chakra-ui/react';
import SkeletonComponent from 'UiKit/skeleton';

import styles from './styles.module.css';

const ClockInSkeleton = () => {
  return (
    <Box className={styles['clock-in-skeleton__container']}>
      <Flex justifyContent="space-between" alignItems="center">
        <Box>
          <SkeletonComponent height="26px" width="82px" mb="4px" />
          <SkeletonComponent height="18px" width="78px" mb="16px" />
        </Box>

        <SkeletonComponent height="34px" width="92px" />
      </Flex>

      <Flex gap="24px">
        <SkeletonComponent height="132px" width="100%" />
        <SkeletonComponent height="132px" width="100%" />
        <SkeletonComponent height="132px" width="100%" />
        <SkeletonComponent height="132px" width="100%" />
      </Flex>
    </Box>
  );
};

export default ClockInSkeleton;
